import { ActionBase } from '../../../core/store/action/ActionBase';
import { RuleCommonParameterModel } from "../../models/RuleCommonParameterModel";

export const GET_COMPARISON_DATE = '[Rule] Get Comparison Date';

export class GetComparisonDateAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_COMPARISON_DATE;

  constructor(public payload: { model: RuleCommonParameterModel }) {

  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/GetComparisonDateAction.ts